/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandDescription} from '../api'

export const useMutationSetBrandDescription = createReactQueryMutationHook('setBrandDescription', setBrandDescription)
